<!-- Simple layout container with a fixed header and an optional fixed footer. The content is scrollable -->
<!-- The layout container itself fills the containing outer div -->
<template>
  <div class="full-height-container">
    <slot></slot>

  </div>

</template>

<script>
export default {
  name: 'FullHeightContainer',
  props: {
    headerBg: String,
  },
};
</script>

<style scoped>
.full-height-container {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  overflow: hidden;
}
</style>